export default Object.freeze({
    AUTH: {
        LOGIN: 'auth.login',
        SIGNUP: 'auth.signup',
        VERIFY_EMAIL: 'auth.verify-email',
        CONFIRM_EMAIL: 'auth.confirm-pending-email',
        FORGOT_PASSWORD: 'auth.forgot-password',
        RESET_PASSWORD: 'auth.reset-password',
        FINALIZE_ACCOUNT: 'auth.finalize-account',
    },
    INDEX: {
        HOME: 'index',
    },
    USER: {
        ME: 'user.me',
        PROFILE: 'user.profile',
        DELETE: 'user.delete',
    },
    OFFER: {
        CREATE: 'offer.create',
        CONFIGURE: 'offer.configure',
        FIND: 'offer.find',
        SINGLE: 'offer.single',
        FAVORITES: 'offer.favorites',
    },
    COMPANY: {
        CREATE: 'company.create',
        MY_COMPANY: 'company.my',
        MY_COMPANIES: 'company.companies',
        PROFILE: 'company.profile',
    },
    INVITATION: {
        ACCEPT_INVITATION: 'invitation.accept-invitation',
    },
    RESERVATIONS: {
        MY: 'reservations.my',
        SINGLE: 'reservations.single',
        RESCHEDULE: 'reservations.reschedule',
        TIMELINE: 'reservations.timeline',
    },
    ERROR: {
        NO_ACCESS: 'errors.no-access',
        NOT_FOUND: 'errors.not-found',
    },
    CALENDAR: {
        MY: 'calendar.my',
    },
    RATING: {
        RATE: 'rating.rate',
    },
    CONTACT: {
        CONTACT: 'contact.contact',
    },
    AGREMENT: {
        TERMS: 'agrement.terms',
        PRIVACY: 'agrement.privacy',
        DISCLAIMER: 'agrement.disclaimer',
    },
    SUBDOMAIN: {
        COMPANY: 'subdomain.company',
        OFFER: 'subdomain.offer',
        RESERVATIONS: 'subdomain.reservations.my',
        CONTACT: 'subdomain.contact',
    },
    QRCODE: {
        INDEX: 'qrcode.index',
    },
    ADMIN: {
        RESERVATIONS: 'admin.reservations',
        ACTIVATE_MEMBER: 'admin.activate-member',
    },
})
